import { jwtDecode, JwtPayload } from "jwt-decode";
import { Theme, Link } from "@mui/material";
import { Maybe } from "api";
import toast from "react-hot-toast";
import { Fragment } from "react";
export * from "./time-ago";
export * from "./formatWithSign";

/**
 * Method for Image Path
 */

export const imagePath = (data: {
  mainUri: string;
  value: string;
}): string | undefined => {
  if (data?.value) {
    if (new RegExp(/https:/).test(data.value)) {
      return data.value;
    }
    return data.mainUri + data.value;
  }
  return undefined;
};

export const isImage = (file: File): boolean => {
  const ext = file.name.split(".").pop() as string;
  if (["png", "jpg", "jpeg", "gif"].includes(ext)) return true;
  return false;
};

export const isDoc = (file: File): boolean => {
  const ext = file.name.split(".").pop() as string;
  if (["pdf"].includes(ext)) return true;
  return false;
};

export const manageAnyHashtag = (text: string): string => {
  const exp = /(?:^|\s)(#[a-zA-Z0-9]\w*)/g;
  const matches = text.match(exp) || [];
  matches.forEach((item) => {
    item = item.replace(/\s/g, "");
    const re1 = new RegExp(`^${item}`, "gi");
    const re2 = new RegExp(`[^[]${item}`, "gi");
    text = text.replace(re1, ` [${item.toLocaleLowerCase()}:${item.slice(1)}]`);
    text = text.replace(re2, ` [${item.toLocaleLowerCase()}:${item.slice(1)}]`);
  });
  return text;
};

export const isJwtExpired = (token: string): boolean => {
  if (typeof token !== "string" || !token)
    throw new Error("Invalid token provided");

  let isJwtExpired = false;
  const { exp } = jwtDecode<JwtPayload>(token);
  const currentTime = new Date().getTime() / 1000;

  if (exp && currentTime > exp) isJwtExpired = true;

  return isJwtExpired;
};

export const isDarkMode = (theme: Theme): boolean =>
  theme.palette.mode === "dark";

export const kFormatter = (num: number): string | number => {
  const absNum = Math.abs(num);

  if (absNum > 999) {
    return `${(absNum / 1000).toFixed(1)}k`;
  }

  return absNum;
};

export const getIsRingVisible = (x: Maybe<number> | undefined): boolean =>
  x === 300;

/**
 * Displays a success toast notification after a post is successfully created.
 *
 * The toast includes a link that allows the user to view the created post in a new tab.
 *
 * @param postId - The unique identifier of the newly created post.
 */
export const showPostSuccessToast = (postId: string) => {
  toast.success(
    <Fragment>
      Post created successfully.&nbsp;
      <Link href={`/posts/${postId}`} target="_blank" rel="noopener">
        view post
      </Link>
    </Fragment>
  );
};
